import { render, staticRenderFns } from "./text-input.vue?vue&type=template&id=3dd00d9c&lang=pug&"
import script from "./text-input.vue?vue&type=script&lang=ts&"
export * from "./text-input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports